import { render, staticRenderFns } from "./ot-invite-user-dialog-wrapper.vue?vue&type=template&id=160e51fa&scoped=true&"
import script from "./ot-invite-user-dialog-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-invite-user-dialog-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-invite-user-dialog-wrapper.vue?vue&type=style&index=0&id=160e51fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e51fa",
  null
  
)

export default component.exports